<template>
  <div style="zoom:0.9;">
      
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t('add') }} {{ $tc('tax', 2) }} {{ $tc('setting', 2) }}</div>
      <router-link class="btn-blue" to="tax-settings">
        {{ $tc('tax', 2) }} {{ $tc('setting', 2) }}
        {{ $tc('list', 2) }}
      </router-link>
    </div>

    <div class="white-wrapper">
      <form>
        <div class="row">
          <div class="col-4 mb-2">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label :class="selectedCinema.length > 0 ? 'shift-up' : '' ">{{ $tc("selectCinema") }}</label>
                <b-dropdown
                  :disabled="isRoleID"
                  :text="selectedCinema"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <div class="px-2 pb-2">
                    <input
                      required
                      autofocus
                      type="search"
                      placeholder="Search Cinema"
                      class="form-control form-control-sm"
                      v-on:keyup="onSearchCinema($event.target.value)"
                      v-on:keydown="onSearchCinema($event.target.value)"
                      v-on:search="onSearchCinema($event.target.value)"
                      v-model="searchCinema"
                      v-b-tooltip.hover
                       :title="$t('chargeSettings_selectCinema')"
                    />
                  </div>
                  <b-dropdown-item
                    href="#"
                    v-for="(Cinema, CinemaIndex) in Cinemas"
                    :key="CinemaIndex"
                    v-on:click="onSelectCinema($event, Cinema)"
                  >{{ Cinema.cine_name }}</b-dropdown-item>
                </b-dropdown>
              </div>

              <!-- <Tooltip :title="$t('chargeSettings_selectCinema')" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && selectedCinema.length == 0">Please Select Cinema.</span>
            </p>
          </div>

          <div class="col-4 mb-2">
            <div class="d-flex justify-content-center align-items-center">
              <div class="input-material">
                <input
                  type="text"
                  v-model="cinemaChargesSettings.pas_charge_setting_name"
                  name="chargesetting"
                  id="chargesetting"
                  v-validate="'required'"
                  placeholder="."
                       v-b-tooltip.hover
                    :title="$t('chargeSettings_ChargeSettingsName')"
                />
                <label>{{ $t('chargesettingname') }}</label>
              </div>

              <!-- <Tooltip :title="$t('chargeSettings_ChargeSettingsName')" /> -->
            </div>
            <p class="error_message">
              <span
                v-if="submitted && errors.has('chargesetting')"
              >{{ errors.first('chargesetting') }}</span>
            </p>
          </div>
          
          <div class="col-2 mb-2">
            <div class="d-flex justify-content-center align-items-center">
              <div class="input-material">
                <input
                  type="text"
                  v-model="cinemaChargesSettings.tax_code"
                  name="tax_code"
                  id="tax_code"
                  placeholder="."
                />
                <label>{{ 'Tax Code' }}</label>
              </div>
            </div>
            <p class="error_message">
            </p>
          </div>

          <div class="col-2 mb-2 align-self-center">
            <div class="d-flex justify-content-start align-items-center mb-3">
            
              
             
              
                <b-form-checkbox
                  unchecked-value="N"
                  v-model="cinemaChargesSettings.pas_is_active"
                  value="Y"
                  name="check-button"
                  class="j-checkbox"
                ></b-form-checkbox>
                  <label class="mb-0">{{ $t('active') }}</label>
            
            </div>
          </div>
          <!-- <div class="col-6 mb-4">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <div class="add-datepicker">
                  <button
                    class="btn-clearDate"
                    v-if="cinemaChargesSettings.pas_start_date"
                    @click.prevent.stop="clearSelectedDate($event, 'pas_start_date')"
                  >✖</button>
                  <Datepicker :monday-first="true"
                    v-model="cinemaChargesSettings.pas_start_date"
                    ref="programaticOpen"
                    name="fd"
                    id="fd"
                    v-validate="'required'"
                  ></Datepicker>
                  <label
                    :class="cinemaChargesSettings.pas_start_date ? 'active': ''"
                  >{{ $t('fromdate') }}</label>
                </div>
              </div>

              <Tooltip :title="$t('chargeSettings_FromDate')" />
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('fd')">{{ errors.first('fd') }}</span>
            </p>
          </div>

          <div class="col-6 mb-4">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <div class="add-datepicker">
                  <button
                    class="btn-clearDate"
                    v-if="cinemaChargesSettings.pas_end_date"
                    v-on:click="clearSelectedDate($event, 'pas_end_date')"
                  >✖</button>
                  <Datepicker :monday-first="true"
                    v-model="cinemaChargesSettings.pas_end_date"
                    ref="programaticOpen"
                    name="td"
                    id="td"
                    v-validate="'required'"
                  ></Datepicker>
                  <label
                    :class="cinemaChargesSettings.pas_end_date ? 'active': ''"
                  >{{ $t('todate') }}</label>
                </div>
              </div>

              <Tooltip :title="$t('chargeSettings_ToDate')" />
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('td')">{{ errors.first('td') }}</span>
            </p>
          </div>-->

          <div
            class="col-12 mb-2"
            v-for="(cinemaChargesSetting, cinemaChargesSettingIndex) in cinemaChargesSettingList"
            :key="cinemaChargesSettingIndex"
          >
            <div class="row border back mx-0 rounded-10 pt-3 pb-1">
              <div class="col-11">
                <div class="row">

                  
                        <div class="col-2 d-flex p-0 justify-content-center">
                          
                          <b-form-checkbox
                            v-model="cinemaChargesSetting.pas_is_percentage"
                            unchecked-value="N"
                            value="Y"
                            name="check-button"
                            class="j-checkbox"
                          ></b-form-checkbox>
                          <label>{{ $t('isPercentage') }}</label>
                        </div>
                     

                  
                        <div class="col-2 d-flex p-0 justify-content-center">
                          
                          <b-form-checkbox
                            v-model="cinemaChargesSetting.pas_is_rebate"
                            unchecked-value="N"
                            value="Y"
                            name="check-button"
                            class="j-checkbox"
                          ></b-form-checkbox>
                          <label>{{ $t('isRebate') }}</label>
                        </div>
                     

                    <div class="col-2 d-flex p-0 justify-content-center">
                            
                          <b-form-checkbox
                            v-model="cinemaChargesSetting.pas_is_deduction"
                            unchecked-value="N"
                            value="Y"
                            name="check-button"
                            class="j-checkbox"
                          ></b-form-checkbox>
                           <label>{{ $t('isdeduction') }}</label>
                        </div>
                     

                    
                        
                        <div class="col-1 d-flex pl-0 justify-content-center">
                           
                          <b-form-checkbox
                            v-model="cinemaChargesSetting.pas_is_taxable"
                            unchecked-value="N"
                            value="Y"
                            name="check-button"
                            class="j-checkbox"
                          ></b-form-checkbox>
                          <label>{{ $t('taxable') }}</label>
                        </div>
                    

                      
                        <div class="col-3 d-flex p-0 justify-content-center">

                          <b-form-checkbox
                            unchecked-value="N"
                            v-model="cinemaChargesSetting.pas_is_shareable_with_distributor"
                            value="Y"
                            name="check-button"
                           class="j-checkbox"
                          ></b-form-checkbox>
                           <label>{{ $t('sharewithdistributor') }}</label>
                        </div>
                     

                    <div class="col-12" v-if="false">
                      <div class="row">
                        <div class="col-8">
                          <label>{{ $t('overandabove') }}</label>
                        </div>
                        <div class="col-4">
                          <b-form-checkbox
                            unchecked-value="N"
                            v-model="cinemaChargesSetting.pas_is_overnabove"
                            value="Y"
                            name="check-button"
                           class="j-checkbox"
                          ></b-form-checkbox>
                        </div>
                      </div>
                    </div>

               
                       
                        <div class="col-2 d-flex p-0 justify-content-center">
                          <b-form-checkbox
                            unchecked-value="N"
                            v-model="cinemaChargesSetting.pas_is_on_gross_amount"
                            value="Y"
                            name="check-button"
                           class="j-checkbox"
                          ></b-form-checkbox>
                            <label>{{ $t('Gross Amount') }}</label>
                        </div>
                  
                  


                  <div class="col-12 align-self-center">
                    <div class="row">
                      <div class="col-6">
                        <div class="dropdown-curve-container">
                          <label
                            :class="cinemaChargesSetting.selectedChargeType.length > 0 ? 'shift-up' : '' "
                          >{{ $tc("chargetype") }}</label>
                          <div class="d-flex justify-content-center align-items-center">
                            <b-dropdown
                              :text="cinemaChargesSetting.selectedChargeType"
                              variant="dropdown-curve"
                              class="w-100"
                              v-b-tooltip.hover
                              :title="$t('chargeSettings_ChargeTypes')"
                            >
                              <b-dropdown-item
                                v-for="(CinemasChargeType, CinemasChargeTypeIndex) in CinemasChargeType"
                                :key="CinemasChargeTypeIndex"
                                v-on:click="onSelectChargeTypes($event, CinemasChargeType, cinemaChargesSettingIndex)"
                              >{{ CinemasChargeType.ct_name }}</b-dropdown-item>
                            </b-dropdown>
                            <!-- <Tooltip :title="$t('chargeSettings_ChargeTypes')" /> -->
                          </div>
                          <p class="error_message">
                            <span
                              v-if="submitted && cinemaChargesSetting.selectedChargeType.length == 0"
                            >Please Select Charge Type.</span>
                          </p>
                        </div>
                      </div>

                      <div class="col-6">
                        <div class="d-flex justify-content-center align-items-center">
                          <div class="input-material">
                            <input
                              type="text"
                              step="any"
                              v-model="cinemaChargesSetting.pas_charge_value"
                              name="chargevalue"
                              id="chargevalue"
                              v-validate="'required|decimal'"
                              placeholder="."
                              v-b-tooltip.hover
                              :title="$t('chargeSetting_chargeValue')"
                            />
                            <label>{{ $t('chargevalue') }}</label>
                          </div>
                          <!-- <Tooltip :title="$t('chargeSetting_chargeValue')" /> -->
                        </div>
                        <p class="error_message">
                          <span
                            v-if="submitted && errors.has('chargevalue')"
                          >{{ errors.first('chargevalue') }}</span>
                        </p>
                      </div>
                    </div>
                  </div>

                
                </div>
              </div>
              <div class="col-1 d-flex justify-content-center align-items-center border-left">
                <button
                  v-if="cinemaChargesSettingIndex === 0"
                  @click.prevent.stop="increaseCinemaChargesSetting()"
                  class="btn-transparent"
                >
                  <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
                </button>
                <button
                  v-else
                  @click.prevent.stop="decreaseCinemaChargesSetting(cinemaChargesSettingIndex)"
                  class="btn-transparent"
                >
                  <img src="@/assets/img/icons/minus.svg" height="35" width="35" />
                </button>
              </div>
            </div>
          </div>
          <!-- <div class="col-12">
            <div class="row">
              <div class="col-1">
                <label>{{ $t('active') }}</label>
              </div>
              <div class="col-4">
                <b-form-checkbox
                  unchecked-value="N"
                  v-model="cinemaChargesSettings.pas_is_active"
                  value="Y"
                  name="check-button"
                  switch
                ></b-form-checkbox>
              </div>
            </div>
          </div> -->
        </div>
        <div class="col-md-12 text-center">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(true)"
            class="btn-blue"
          >{{ $t('save') }}</button>
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(false)"
            class="btn-blue"
          >{{ $t('saveaddmore') }}</button>
          <button @click.prevent.stop="onResetForm()" class="btn-black">{{ $t('reset') }}</button>
          <b-button
            @click.prevent.stop="onCancel()"
            class="btn-outline-grey"
            variant="default"
          >{{ $t('cancel') }}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import DistributorService from "@/services/DistributorService";
import CinemasService from "@/services/CinemasService";
import MovieService from "@/services/MovieService";
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      btenable: false,
      isRoleID: true,
      submitted: false,
      searchCinema: "",
      // Saif
      Cinemas: [],
      CinemasCopy: [],
      CinemasChargeType: [],
      selectedChargeType: "",
      selectedCinema: "",

      cinemaChargesSettings: {
        pas_charge_setting_name: "",
        tax_code: "",
        cinema_id: null,
        pas_end_date: null,
        pas_start_date: null,
        pas_is_active: "Y",
        created_at: "",
        created_by: "",
        updated_by: "",
        updated_at: "",
      },
      cinemaChargesSettingList: [
        {
          pas_id: null,
          selectedChargeType: "",
          charge_type_id: null,
          // pas_start_date: null,
          // pas_end_date: null,
          pas_charge_value: "",
          pas_is_percentage: "Y",
          pas_is_rebate: "N",
          pas_is_deduction: "Y",
          pas_is_taxable: "Y",
          pas_is_shareable_with_distributor: "Y",
          pas_is_overnabove: "Y",
          pas_is_on_gross_amount: "Y",
          created_at: "",
          created_by: "",
          updated_by: "",
          updated_at: "",
        },
      ],

      // Saif
      validate: false,
    };
  },
  computed: {
    validStatus() {
      return this.validate ? true : false;
    },
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    this.getCinemaList(obj);
    this.getChargeTypeList();
  },
  mounted() {},

  methods: {
    clearSelectedDate: function (event, name) {
      this.cinemaChargesSettings[name] = null;
    },
    onSearchCinema: function (value) {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    // Saif
    getCinemaList: function (cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                // this.selectedCinema = x.cine_name;
                this.onSelectCinema(null, {
                  cine_id: x.cine_id,
                  cine_name: x.cine_name,
                });
              }
            });
            // console.log("this.Cinemas :", this.Cinemas);
          } else {
            // Show Error Message
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          console.log("Catch On GetActiveCinemas :", error);
        });
    },
    getChargeTypeList: function () {
      CinemasService.GetActiveCinemasChargeType({ activekey: "ct_is_active" })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.CinemasChargeType = data.Records;
          } else {
            // Show Error Message
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          console.log("Catch On GetActiveCinemas :", error);
        });
    },
    onSelectCinema: function (event, params) {
      this.selectedCinema = params.cine_name;
      this.cinemaChargesSettings.cinema_id = params.cine_id;
    },
    onFinalSubmit: function (redirect) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        // console.log("Valid :", valid);
        if (valid) {
          this.btenable = true;
          let payload = {
            ...this.cinemaChargesSettings,
            CinemaChargesSettingList: this.cinemaChargesSettingList,
          };
          console.log("payload :", payload);
          CinemasService.AddCinemaCharges(payload)
            .then((response) => {
              this.btenable = false;
              const { data } = response;
              if (data && data.status) {
                this.onResetForm();
                if (redirect) {
                  this.$router.push({
                    path: "/Cinema-manager/tax-settings",
                  });
                }
                this.submitted = false;
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError); //message
        }
      });
    },
    onResetForm: function () {
      this.selectedChargeType = "";
      this.selectedCinema = "";
      this.cinemaChargesSettings = {
        pas_id: null,
        cinema_id: null,
        created_at: "",
        created_by: "",
        updated_by: "",
        updated_at: "",
      };
      this.cinemaChargesSettingList = [
        {
          selectedChargeType: "",
          charge_type_id: null,
          // pas_start_date: null,
          // pas_end_date: null,
          pas_charge_value: "",
          pas_is_percentage: "Y",
          pas_is_rebate: "N",
          pas_is_deduction: "Y",
          pas_is_taxable: "Y",
          pas_is_shareable_with_distributor: "Y",
          pas_is_overnabove: "Y",
          pas_is_on_gross_amount:"Y",
          pas_is_active: "Y",
          created_at: "",
          created_by: "",
          updated_by: "",
          updated_at: "",
        },
      ];
    },
    onCancel: function () {
      this.$router.push({
        path: "/Cinema-manager/tax-settings",
      });
    },
    onSelectChargeTypes: function (event, params, cinemaChargesSettingIndex) {
      this.cinemaChargesSettingList[
        cinemaChargesSettingIndex
      ].selectedChargeType = params.ct_name;
      this.cinemaChargesSettingList[cinemaChargesSettingIndex].charge_type_id =
        params.ct_id;
    },
    increaseCinemaChargesSetting: function () {
      this.cinemaChargesSettingList.push({
        pas_id: null,
        selectedChargeType: "",
        charge_type_id: null,
        // pas_start_date: null,
        // pas_end_date: null,
        pas_charge_value: "",
        pas_is_percentage: "Y",
        pas_is_rebate: "N",
        pas_is_deduction: "Y",
        pas_is_taxable: "Y",
        pas_is_shareable_with_distributor: "Y",
        pas_is_overnabove: "Y",
        pas_is_on_gross_amount:"Y",
        pas_is_active: "Y",
        created_at: "",
        created_by: "",
        updated_by: "",
        updated_at: "",
      });
    },
    decreaseCinemaChargesSetting: function (index) {
      this.cinemaChargesSettingList.splice(index, 1);
    },
    // Saif
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ChargeSettingComponents/addChargeSetting.vue